module.exports = __webpack_public_path__ + "img/Upload.e3b641ef.svg";